// for each product type return a set of valid subtypes
import {ProductSubType, ProductType} from "../api/Constants";

export const getSubTypeOptions = (type) => {
    let options;
    switch (type) {
        case ProductType.Flower:
        case ProductType.InfusedFlower:
            // 1g
            // 3.5g
            // 7g
            // 14g
            // 28g
            // LBs
            options = [
                {value: ProductSubType.OneGram, label: ProductSubType.Label[ProductSubType.OneGram]},
                {value: ProductSubType.ThreePointFiveGram, label: ProductSubType.Label[ProductSubType.ThreePointFiveGram]},
                {value: ProductSubType.SevenGram, label: ProductSubType.Label[ProductSubType.SevenGram]},
                {value: ProductSubType.FourteenGram, label: ProductSubType.Label[ProductSubType.FourteenGram]},
                {value: ProductSubType.TwentyEightGram, label: ProductSubType.Label[ProductSubType.TwentyEightGram]},
                {value: ProductSubType.LBs, label: ProductSubType.Label[ProductSubType.LBs]},
            ]
            break;
        case ProductType.PreRoll:
        case ProductType.InfusedPreroll:
            // 1g
            // .75g
            // .5g
            // 2.5g
            // 3.5g
            // 1.5G+.3g
            options = [
                {value: ProductSubType.OneGram, label: ProductSubType.Label[ProductSubType.OneGram]},
                {value: ProductSubType.PointSevenFiveGram, label: ProductSubType.Label[ProductSubType.PointSevenFiveGram]},
                {value: ProductSubType.PointFiveGram, label: ProductSubType.Label[ProductSubType.PointFiveGram]},
                {value: ProductSubType.TwoPointFiveGram, label: ProductSubType.Label[ProductSubType.TwoPointFiveGram]},
                {value: ProductSubType.ThreePointFiveGram, label: ProductSubType.Label[ProductSubType.ThreePointFiveGram]},
            ];
            break;
        case ProductType.Beverage:
        case ProductType.Wellness:
            // 10mg
            // 25mg
            // 100mg
            options = [
                {value: ProductSubType.TenMilligram, label: ProductSubType.Label[ProductSubType.TenMilligram]},
                {value: ProductSubType.TwentyFiveMilligram, label: ProductSubType.Label[ProductSubType.TwentyFiveMilligram]},
                {value: ProductSubType.HundredMilligram, label: ProductSubType.Label[ProductSubType.HundredMilligram]},
            ]
            break;
        case ProductType.Extract:
            // 1g
            // bulk
            // Liters
            // 2g
            options = [
                {value: ProductSubType.OneGram, label: ProductSubType.Label[ProductSubType.OneGram]},
                {value: ProductSubType.Bulk, label: ProductSubType.Label[ProductSubType.Bulk]},
                {value: ProductSubType.Liters, label: ProductSubType.Label[ProductSubType.Liters]},
                {value: ProductSubType.TwoGram, label: ProductSubType.Label[ProductSubType.TwoGram]},
            ]
            break;
        case ProductType.Vape:
            // 1g
            // 2g
            options = [
                {value: ProductSubType.OneGram, label: ProductSubType.Label[ProductSubType.OneGram]},
                {value: ProductSubType.TwoGram, label: ProductSubType.Label[ProductSubType.TwoGram]},
            ]
            break;
        case ProductType.Edible:
            // 10mg
            // 25mg
            // 100mg
            options = [
                {value: ProductSubType.TenMilligram, label: ProductSubType.Label[ProductSubType.TenMilligram]},
                {value: ProductSubType.TwentyFiveMilligram, label: ProductSubType.Label[ProductSubType.TwentyFiveMilligram]},
                {value: ProductSubType.HundredMilligram, label: ProductSubType.Label[ProductSubType.HundredMilligram]},
            ];
            break;
        case ProductType.Clothing:
            options = [
                {value: ProductSubType.XS, label: ProductSubType.Label[ProductSubType.XS]},
                {value: ProductSubType.S, label: ProductSubType.Label[ProductSubType.S]},
                {value: ProductSubType.M, label: ProductSubType.Label[ProductSubType.M]},
                {value: ProductSubType.L, label: ProductSubType.Label[ProductSubType.L]},
                {value: ProductSubType.XL, label: ProductSubType.Label[ProductSubType.XL]},
                {value: ProductSubType.XXL, label: ProductSubType.Label[ProductSubType.XXL]},
                {value: ProductSubType.XXXL, label: ProductSubType.Label[ProductSubType.XXXL]},
            ]
            break;
        default:
            options = [];
            break;
    }

    return options;
}